import React from 'react';
import { connect } from '@gasbuddy/react';
import { Text } from '@gasbuddy/react-components';
import _ from 'lodash';
import StatusIcons from './status-icons';
import styles from './styles.css';
import GridColumns from '../../grid-columns';
import BannerMessage from '../../banner-message';
import { getStatusDisplayName, mapEmergencyStatusesToObject, computeClosingHour } from './helper';
import StationPropType from '../../../utils/prop-types/station';

const { isFeatureEnabled } = require('../../../../lib/bputils').default;

class ViewContent extends React.Component {
  static propTypes = {
    station: StationPropType,
  };

  static defaultProps = {
    station: null,
  }

  constructor(props) {
    super(props);

    this.state = {
      openStatus: this.props.station.open_status,
      openingHours: this.props.station.opening_hours,
      emergencyStatus: this.props.station.emergency_status,
    };
  }

  attachEmergencyStatusContent = (viewContent) => {
    const { emergencyStatus } = this.state;

    // only display emergency status if station is in emergency
    if (emergencyStatus) {
      viewContent.push({
        key: 'selectedEmergencyStatus',
        body: (
          <div className={styles.statusContainer}>
            <StatusIcons
              emergencyStatusObject={mapEmergencyStatusesToObject(emergencyStatus)}
            />
          </div>
        ),
      });
    }

    return viewContent;
  }

  componentDidUpdate = (prevProps) => {
    const { station: { open_status: openStatus, emergency_status: emergencyStatus, opening_hours: openingHours } } = this.props;
    const newState = {};

    if (!_.isEqual(openStatus, prevProps.station.open_status)) {
      newState.openStatus = openStatus;
    }

    if (!_.isEqual(emergencyStatus, prevProps.station.emergency_status)) {
      newState.emergencyStatus = emergencyStatus;
    }

    if (!_.isEqual(openingHours, prevProps.station.opening_hours)) {
      newState.openingHours = openingHours;
    }

    if (Object.keys(newState).length) {
      this.setState(() => newState);
    }
  }

  render = () => {
    const { openStatus, openingHours } = this.state;

    let viewContent = [{
      key: 'selectedOpenStatus',
      body: (
        <div className={styles.statusCardContent}>
          <h5 className={styles.statusHoursTitle}>{getStatusDisplayName(openStatus)}</h5>
          {openStatus === 'open' && <Text className={styles.statusTodayHours}>{computeClosingHour(openingHours)}</Text>}
        </div>
      ),
    }];

    if (isFeatureEnabled('emergency_features')) {
      viewContent = this.attachEmergencyStatusContent(viewContent);
    }

    return (
      <div className={styles.statusMain}>
        { _.isEmpty(openStatus) ? <BannerMessage message="PLEASE UPDATE YOUR STATION STATUS" /> : <GridColumns contents={viewContent} />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  station: state.station,
});

export default connect(mapStateToProps)(ViewContent);
